var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSmartphone(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 512 512",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#009FD3"
    },
    d: "M10.667,95.997h490.667V85.533c0-17.713-14.488-32.201-32.198-32.201H42.867 c-17.71,0-32.201,14.488-32.201,32.201V95.997z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 10.667,
    y: 95.997,
    style: {
      fill: "#00E58B"
    },
    width: 490.67,
    height: 202.668
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#009FD3"
    },
    d: "M501.333,298.667H10.667v21.132c0,17.709,14.491,32.202,32.201,32.202h159.8h106.666h159.802 c17.71,0,32.198-14.493,32.198-32.202V298.667z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#009FD3"
    },
    points: "309.334,352.001 202.668,352.001 181.333,415.998 330.667,415.998  "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#009FD3"
    },
    d: "M330.667,415.998H181.333c-11.733,0-21.332,9.601-21.332,21.332v15.316 c0,3.311,2.708,6.019,6.018,6.019h179.963c3.312,0,6.021-2.708,6.021-6.019v-15.316 C352.002,425.598,342.403,415.998,330.667,415.998z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#000003"
    },
    d: "M469.135,42.666H42.867C19.23,42.666,0,61.897,0,85.533v234.266 c0,23.637,19.23,42.869,42.867,42.869h145.001l-14.562,43.685c-13.774,3.57-23.972,16.104-23.972,30.978v10.67h-32.001 c-5.89,0-10.667,4.777-10.667,10.667c0,5.89,4.775,10.667,10.667,10.667h48.686h0.002h179.961h48.687 c5.89,0,10.667-4.777,10.667-10.667c0-5.89-4.777-10.667-10.667-10.667h-32v-10.67c0-14.873-10.202-27.407-23.975-30.978 l-14.56-43.685h145.001c23.635,0,42.864-19.23,42.864-42.869V85.533C512,61.897,492.771,42.666,469.135,42.666z M170.668,437.331 c0-5.882,4.784-10.666,10.666-10.666h149.333c5.883,0,10.669,4.784,10.669,10.666v10.67H170.668V437.331z M315.868,405.332H196.133 l14.222-42.664h91.29L315.868,405.332z M469.135,341.334h-159.8H202.668h-159.8c-11.873,0-21.534-9.661-21.534-21.535v-10.465 h405.2c5.89,0,10.667-4.777,10.667-10.667s-4.777-10.667-10.667-10.667h-405.2V85.533c0-11.874,9.661-21.534,21.534-21.534h426.267 c11.804,0,21.41,9.551,21.521,21.331H87.174c-5.89,0-10.667,4.777-10.667,10.667c0,5.891,4.777,10.667,10.667,10.667h403.493 v213.135C490.667,331.674,481.008,341.334,469.135,341.334z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#000003"
    },
    d: "M318.326,131.507l-23.589-0.113c-5.429-0.022-9.923,4.036-10.581,9.293l-3.231,25.482l-5.565,43.911 l-63.025-4.197l-5.886-33.016h42.355c5.891,0,10.668-4.775,10.668-10.665c0-5.893-4.777-10.669-10.668-10.669h-55.083v0.009 c-0.606,0-1.218,0.052-1.835,0.156c-5.799,1.012-9.678,6.538-8.668,12.335l9.585,53.751h0.01c0.822,4.726,4.782,8.459,9.78,8.793 l81.336,5.412l0.002-0.022c5.571,0.379,10.538-3.654,11.248-9.267l6.827-53.863l2.046-16.151l14.192,0.07 c5.863,0.021,10.641-4.719,10.662-10.584C328.931,136.307,324.194,131.527,318.326,131.507z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#000003"
    },
    d: "M219.383,241.94c-5.874,0-10.666,4.792-10.666,10.665c0,5.876,4.792,10.668,10.666,10.668 c5.874,0,10.666-4.792,10.666-10.668C230.048,246.731,225.257,241.94,219.383,241.94z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#000003"
    },
    d: "M273.76,241.94c-5.874,0-10.666,4.792-10.666,10.665c0,5.876,4.792,10.668,10.666,10.668 c5.874,0,10.664-4.792,10.664-10.668C284.424,246.731,279.634,241.94,273.76,241.94z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#000003"
    },
    d: "M54.465,85.331h-4.791c-5.89,0-10.667,4.777-10.667,10.667c0,5.891,4.777,10.667,10.667,10.667 h4.791c5.89,0,10.667-4.775,10.667-10.667C65.132,90.107,60.356,85.331,54.465,85.331z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#000003"
    },
    d: "M461.845,288.001h-4.51c-5.89,0-10.667,4.777-10.667,10.667s4.777,10.667,10.667,10.667h4.51 c5.891,0,10.667-4.777,10.667-10.667S467.736,288.001,461.845,288.001z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmartphone);
export default __webpack_public_path__ + "static/media/smartphone.d9f1f374f1a41505057a7b6fafb3a2e9.svg";
export { ForwardRef as ReactComponent };